<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>


<style lang="scss">
  @import './styles/index.scss'; // 全局自定义的css样式
  @import './styles/element-ui.scss'; // 全局自定义的css样式
</style>



// WEBPACK FOOTER //
// src/App.vue?1da7b8a2